import axios from "./axios-auth";

const getAllClients = (data) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getallclients",
      params: {},
      data: data,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, "resp from getAllClients api");
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        alert(err);
        console.log("error from api folder while calling axios");
      });
  });

const getClientById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getclientbyid",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "get client by id api");
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        alert(err);
        console.log("error from api folder while calling axios");
      });
  });

const insertClient = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addClient",
      data: params,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, " from insert supplier api");
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log(err, "from insert supplier api");
      });
  });

const editClient = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateClientById",
      data: params,
      method: "PUT",
    })
      .then((resp) => {
        console.log(resp, " from edit client api");
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log(err, "from edit client api");
      });
  });

const deleteClient = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deleteClientById",
      params: params,
      method: "DELETE",
    })
      .then((resp) => {
        console.log(resp, " from delete supplier api");
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log(err, "from delete supplier api");
      });
  });

const getClientCategoryTree = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getclientcategorytree",
      data: payload,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error from getClientCategoryTree api");
      });
  });

const getClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getclients",
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error from getClients api");
      });
  });

const updateClientCategoryMapping = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateclientcategorymapping",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error from updateClientCategoryMapping api");
      });
  });

const getCurrencies = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getcurrencies",
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log("error from getCurrencies api");
      });
  });

const changeCategoryExclusionForClient = async (payload) => {
  try {
    const resp = await axios.put("/dv-adm/changecategoryexclusion", payload)
    return resp
  }
  catch (e) {
    console.error(e)
    return e
  }
}

export {
  getAllClients,
  getClientById,
  insertClient,
  editClient,
  deleteClient,
  getClientCategoryTree,
  getClients,
  updateClientCategoryMapping,
  getCurrencies,
  changeCategoryExclusionForClient
};
